"use client";

import { Disc3, Instagram, Youtube, Music2, MapPin, CreditCard } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const shopLinks = [{
  label: "Startseite",
  to: "/HomePage"
}, {
  label: "Die Lösung",
  to: "/SolutionPage"
}, {
  label: "Gesetzliches",
  to: "/LegalPage"
}, {
  label: "Kontakt",
  to: "/ContactPage"
}];
const infoLinks = [{
  label: "Über uns",
  to: "#"
}, {
  label: "Referenzen",
  to: "#"
}, {
  label: "Wartung",
  to: "#"
}, {
  label: "Karriere",
  to: "#"
}, {
  label: "Impressum",
  to: "#"
}, {
  label: "Datenschutz",
  to: "#"
}];
const socials = [{
  label: "Instagram",
  icon: Instagram,
  to: "#"
}, {
  label: "YouTube",
  icon: Youtube,
  to: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-5 w-32 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default italic text-base text-foreground/80 hover:text-primary transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const marqueeText = "NABER AIRCONDUCT · DUCTED AC SYSTEM · ";
export default function Footer() {
  return <section data-section-id="433" id="fußbereich" className="relative bg-background text-foreground overflow-hidden border-t border-border">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      {}
      <div className="relative border-b border-border bg-background overflow-hidden">
        <div className="flex whitespace-nowrap py-2.5 animate-[marquee_40s_linear_infinite]">
          {Array.from({
          length: 12
        }).map((_, i) => <span data-index={i} key={i} className="font-mono text-xs uppercase tracking-[0.2em] text-primary px-4" style={{
          color: "var(--chart-1)"
        }}>
              {marqueeText}
            </span>)}
        </div>
        <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>

      {}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        {}
        <div className="hidden md:grid grid-cols-5 gap-10 lg:gap-14">
          {}
          <div className="col-span-2 space-y-6">
            <Link to="/" className="inline-flex items-center gap-3 group">
              <div className="relative">
                <Disc3 className="h-10 w-10 text-primary transition-transform duration-700 group-hover:rotate-180" strokeWidth={1.5} />
              </div>
              <span className="font-default text-3xl font-semibold tracking-tight text-foreground">
                NABER AIRCONDUCT
              </span>
            </Link>

            <p className="font-default text-sm leading-relaxed text-muted-foreground max-w-[320px]">
              Ducted AC System für Ihr Zuhause. Wir planen und installieren hocheffiziente Luft-Luft-Wärmepumpen, die diskret im Dachboden verschwinden und für ein perfektes Raumklima sorgen.
            </p>

            <div className="flex items-center gap-3 pt-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link data-index={i} key={social.label} to={social.to} aria-label={social.label} className="group relative inline-flex items-center justify-center h-10 w-10 rounded-lg border border-border bg-transparent hover:border-primary transition-all duration-300" style={{
                borderRadius: "0px"
              }}>
                    <Icon className="h-4 w-4 text-foreground/70 group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
                    <span className="absolute inset-0 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                  boxShadow: "0 0 20px var(--primary)",
                  borderRadius: "0px"
                }} />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="space-y-5">
            <h3 className="font-default font-mono text-xs uppercase tracking-[0.25em] text-primary">
              Navigation
            </h3>
            <ul className="space-y-3">
              {shopLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.url_path} className="font-default italic text-base text-foreground/80 hover:text-primary transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-5">
            <h3 className="font-default font-mono text-xs uppercase tracking-[0.25em] text-primary">
              Service
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
            <ul className="space-y-3 hidden">
              {infoLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="font-default italic text-base text-foreground/80 hover:text-primary transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-5">
            <h3 className="font-default font-mono text-xs uppercase tracking-[0.25em] text-primary">
              Standort
            </h3>
            <address className="not-italic font-default text-base text-foreground/80 leading-relaxed">
              Bachstr. 33<br />
              73630 Remshalden
            </address>
            <div className="font-mono text-xs text-muted-foreground leading-relaxed space-y-1">
              <div>MO–SA · 08:30–18:00</div>
            </div>
            <Link to="/ContactPage" className="relative block w-full h-24 rounded-lg overflow-hidden border border-border group">
              <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/naber_airconduct_map_preview.png)] opacity-70 group-hover:opacity-90 transition-opacity duration-500" />
              <div className="absolute inset-0 bg-background/40" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background/80 backdrop-blur-sm border border-border">
                  <MapPin className="h-3.5 w-3.5 text-primary" strokeWidth={2} />
                  <span className="font-mono text-[10px] uppercase tracking-wider text-foreground">
                    Anfahrt
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {}
        <div className="md:hidden space-y-8">
          <div className="space-y-6">
            <Link to="/" className="inline-flex items-center gap-3">
              <Disc3 className="h-9 w-9 text-primary" strokeWidth={1.5} />
              <span className="font-default text-2xl font-semibold tracking-tight text-foreground">
                NABER AIRCONDUCT
              </span>
            </Link>
            <p className="font-default text-sm leading-relaxed text-muted-foreground">
              Ducted AC System für Ihr Zuhause. Hocheffizient, leise und perfekt integriert.
            </p>
            <div className="flex items-center gap-3">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link data-index={i} key={social.label} to={social.to} aria-label={social.label} className="inline-flex items-center justify-center h-10 w-10 border border-border hover:border-primary transition-colors" style={{
                borderRadius: "0px"
              }}>
                    <Icon className="h-4 w-4 text-foreground/70" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

          <Accordion type="single" collapsible className="border-t border-border">
            <AccordionItem value="shop" className="border-border">
              <AccordionTrigger className="font-mono text-xs uppercase tracking-[0.25em] text-primary hover:no-underline">
                Navigation
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-3 pt-2">
                  {shopLinks.map((link, i) => <li data-index={i} key={link.label}>
                      <Link to={link.url_path} className="font-default italic text-base text-foreground/80">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="info" className="border-border">
              <AccordionTrigger className="font-mono text-xs uppercase tracking-[0.25em] text-primary hover:no-underline">
                Service
              </AccordionTrigger>
              <AccordionContent>
                <MenuProvider menu_id="17" className="pt-2">
                  <FooterMenuConsumer />
                </MenuProvider>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="visit" className="border-border">
              <AccordionTrigger className="font-mono text-xs uppercase tracking-[0.25em] text-primary hover:no-underline">
                Standort
              </AccordionTrigger>
              <AccordionContent>
                <div className="space-y-4 pt-2">
                  <address className="not-italic font-default text-base text-foreground/80 leading-relaxed">
                    Bachstr. 33<br />
                    73630 Remshalden
                  </address>
                  <div className="font-mono text-xs text-muted-foreground space-y-1">
                    <div>MO–SA · 08:30–18:00</div>
                  </div>
                  <Link to="/ContactPage" className="relative block w-full h-24 rounded-lg overflow-hidden border border-border">
                    <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/naber_airconduct_map_preview.png)] opacity-70" />
                    <div className="absolute inset-0 bg-background/40" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background/80 backdrop-blur-sm border border-border">
                        <MapPin className="h-3.5 w-3.5 text-primary" strokeWidth={2} />
                        <span className="font-mono text-[10px] uppercase tracking-wider text-foreground">
                          Anfahrt
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>

        {}
        <div className="relative mt-16 lg:mt-20 mb-8">
          <Separator className="bg-primary/30" />
          <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 bg-background px-4">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-primary/70 whitespace-nowrap">
              NABER AIRCONDUCT · DUCTED AC SYSTEM · STUTTGART
            </span>
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-muted-foreground order-2 md:order-1">
            © 2025 Naber AirConduct. Alle Rechte vorbehalten.
          </p>

          <div className="flex items-center gap-4 order-1 md:order-2 opacity-60">
            <CreditCard className="h-4 w-4 text-foreground/60" strokeWidth={1.5} />
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Rechnung · Überweisung · Leasing
            </span>
          </div>

          <p className="font-default italic text-xs text-muted-foreground order-3">
            Ducted AC System für Ihr Zuhause.
          </p>
        </div>
      </div>
    </section>;
}